import React from "react";
import { Box, Typography } from "@mui/material";
import CreditsInfo from "./CreditsInfo.js";
import { blue } from "@mui/material/colors";

const CreditsInfoPage = () => {
    return (
        <Box
            sx={{
                padding: { xs: 2, md: 3 },
                minHeight: "100vh",
                backgroundColor: "background.default",
            }}
        >
            <Typography
                variant="h6"
                sx={{
                    mb: 4,
                    mt: 1,
                    color: "primary.main",
                    backgroundColor: blue[50],
                    px: 2,
                    width: "fit-content",
                    py: 1,
                    borderRadius: 2,
                    fontWeight: "bold",
                }}
            >
                Credits Information
            </Typography>
            <CreditsInfo />
        </Box>
    );
};

export default CreditsInfoPage;
